import { Tooltip, Button, useClipboard, TooltipProps, ButtonProps, Text, Icon } from "@/index"
import React from "react"

interface CopyToClipboardProps extends ButtonProps {
  value: string,
  text?: string,
  tips?: string,
  copiedTips?: string,
  tooltipProps?: TooltipProps,
}

const Component = React.forwardRef((props: CopyToClipboardProps, ref: React.Ref<any>) => {
  const {
    value,
    text,
    tips = 'Copy',
    copiedTips = 'Copied!',
    tooltipProps,
    ...otherProps
  } = props

  const { hasCopied, onCopy } = useClipboard(value)

  const mergeTooltipProps = {
    hasArrow: true,
    label: hasCopied ? copiedTips : tips,
    placement: 'top' as any,
    color: hasCopied ? 'scene.success.normal' : 'inherit',
    isOpen: hasCopied ? hasCopied : undefined,
    ...tooltipProps,
  }

  return (
    <Tooltip { ...mergeTooltipProps }>
      <Button onClick={onCopy} { ...otherProps }>
        <Icon.Copy />{text !== undefined ? <Text ml='3xs'>{text}</Text> : null}
      </Button>
    </Tooltip>
  )
})


export {
  Component as CopyToClipboard,
  type CopyToClipboardProps
}